<template>
  <div>
    <ul id="nav">
      <li><a href="javascript:;" @click="linkTo(1)">活动介绍</a></li>
      <li><a href="javascript:;" @click="linkTo(2)">参赛证</a></li>
      <li><a href="javascript:;" @click="linkTo(3)">比赛成绩</a></li>
      <li><a href="javascript:;" @click="linkTo(4)">我的团队</a></li>
    </ul>

    <div class="container" v-if="result.isEdit == 'y'">
      <div class="backWrap" >
          <span @click="back">
              &lt; 返回
          </span>
      </div>
      <div class="section">
        <h2 class="section-title">个人信息</h2>
        <div class="line clearfix">
          <div class="line-50">
            <span class="label">姓名</span>
            <span class="text inaline">{{result.user_realname}}</span>
          </div>
          <div class="line-50">
            <span class="label">身份</span>
            <span class="text">{{result.user_is_leader == 'y' ? '队长' : '队员'}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-50">
            <span class="label">参赛编号</span>
            <span class="text">{{result.user_serial_number}}</span>
          </div>
          <div class="line-50">
            <span class="label">所在分组</span>
            <span class="text">{{result.teamId}}</span>
          </div>
        </div>

        <div class="line clearfix">
          <div class="line-100">
            <span class="label">年龄</span>
            <span class="text">{{result.age}}岁</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">从业时间</span>
            <span class="text">{{result.yearsOfWork}}年</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">年收入</span>
            <span class="text">{{result.yearOfIncome}}万元</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">擅长品类</span>
            <span class="text">{{result.goodAtCategory}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">手机号码</span>
            <span class="text">{{result.phone}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">身份证号</span>
            <span class="text">{{result.user_id_number}}</span>
          </div>
        </div>
        
      </div>
      <div class="section">
        <h2 class="section-title">家庭信息</h2>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">婚姻状况</span>
            <span class="text">{{result.marryStatus}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">子女数量</span>
            <span class="text">{{result.numberOfChildren}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">籍贯</span>
            <span class="text">{{result.nativePlace}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">现居地址</span>
            <span class="text">{{result.address}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100" style="padding-left: 2.0rem;">
            <span class="label" style="width: 1.8rem;left: 0rem;">杭州居住时间</span>
            <span class="text">{{result.residenceTimeInHangzhou}}年</span>
          </div>
        </div>
        
      </div>
    </div>

    <div class="container" v-if="result.isEdit != 'y'">
      <div class="backWrap" >
        <span @click="back">
            &lt; 返回
        </span>
      </div>
      <div class="section">
        <h2 class="section-title">个人信息</h2>
        <div class="line clearfix">
          <div class="line-50">
            <span class="label">姓名</span>
            <span class="text inaline">{{result.user_realname}}</span>
          </div>
          <div class="line-50">
            <span class="label">身份</span>
            <span class="text">{{result.user_is_leader == 'y' ? '队长' : '队员'}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-50">
            <span class="label">参赛编号</span>
            <span class="text">{{result.user_serial_number}}</span>
          </div>
          <div class="line-50">
            <span class="label">所在分组</span>
            <span class="text">{{result.team_id}}</span>
          </div>
        </div>

        <div class="line clearfix">
          <div class="line-100">
            <span class="label">年龄</span>
            <input class="input" type="tel" v-model.trim="form.age" placeholder="请输入年龄">
			      <i class="unit">周岁</i>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">从业时间</span>
            <input class="input" type="tel" v-model.trim="form.workTime" placeholder="请输入从业时间">
					  <i class="unit">年</i>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">年收入</span>
            <input class="input" type="tel" v-model.trim="form.yearIncome" placeholder="请输入年收入">
					  <i class="unit">万</i>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">擅长品类</span>
            <input class="input" type="text" v-model.trim="form.category" readonly @click="showPicker(1)"  placeholder="请点击选择">
					  <i class="icon_down"></i>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">手机号码</span>
            <span class="text">{{result.phone}}</span>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">身份证号</span>
            <span class="text">{{result.user_id_number}}</span>
          </div>
        </div>
        
      </div>
      <div class="section">
        <h2 class="section-title">家庭信息</h2>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">婚姻状况</span>
            <input class="input" type="text" v-model.trim="form.marryState" readonly @click="showPicker(2)" placeholder="请点击选择">
					  <i class="icon_down"></i>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">子女数量</span>
            <input class="input" type="tel" v-model.trim="form.childNumber" placeholder="请输入子女数量">
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">籍贯</span>
            <input class="input" type="text"  v-model.trim="form.city" readonly @click="showAddressPicker" placeholder="请点击选择">
					  <i class="icon_down"></i>
          </div>
        </div>
        
        <div class="line clearfix">
          <div class="line-100">
            <span class="label">现居地址</span>
            <textarea class="input textarea" v-model.trim="form.detailAddress" placeholder="请输入详细居住地址"></textarea>
          </div>
        </div>
        <div class="line clearfix">
          <div class="line-100" style="padding-left: 2.0rem;">
            <span class="label" style="width: 1.8rem;left: 0rem;">杭州居住时间</span>
            <input class="input" type="tel" v-model.trim="form.liveHereTime" placeholder="请输入在杭居住时间">
					<i class="unit">年</i>
          </div>
        </div>
        <div class="add-invite">
            <span class="add-btn" @click="submit">确认补充信息</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { validateMobile, validateIdCard, validateNumber, validateFloatNumber } from '@/utils/validate'
import { getUserInfo, supplyUserInfo } from '@/api/index'
const column1 = [
	{ text: '职业装', value: '职业装'},
	{ text: '上衣', value: '上衣' },
	{ text: '连衣裙', value: '连衣裙' },
	  
	{ text: '毛衣', value: '毛衣' },
	{ text: 'T恤', value: 'T恤' },
	{ text: '外套', value: '外套' },
	{ text: '旗袍', value: '旗袍' },
	{ text: '礼服', value: '礼服' },
	{ text: '呢料大衣', value: '呢料大衣' },
	{ text: '风衣', value: '风衣' },
	{ text: '卫衣', value: '卫衣' },
	{ text: '皮衣', value: '皮衣' },
	{ text: '连体裤', value: '连体裤' },
	{ text: '棉服', value: '棉服' },
	{ text: '衬衫', value: '衬衫' },
	{ text: '长裤', value: '长裤' },
	{ text: '半裙', value: '半裙' },
	{ text: '短裙', value: '短裙' },
	{ text: '连体裙', value: '连体裙' },
	{ text: '套裤', value: '套裤' },
	{ text: '套裙', value: '套裙' },
	{ text: '西服套装', value: '西服套装' },
	{ text: '家居服', value: '家居服' },
	{ text: '羽绒棉服', value: '羽绒棉服' },
	{ text: 'POLO衫', value: 'POLO衫' },
	{ text: '休闲西服', value: '休闲西服' },
	{ text: '马甲', value: '马甲' },
	{ text: '休闲裤', value: '休闲裤' },
	{ text: '毛呢大衣', value: '毛呢大衣' },
	{ text: '七分裤', value: '七分裤' },
	{ text: '短裤', value: '短裤' },
]

const column2 = [
	{ text: '已婚', value: '已婚'},
	{ text: '未婚', value: '未婚' }
]

import { provinceList, cityList, areaList } from '@/utils/area'

const addressData = provinceList
addressData.forEach(province => {
  province.children = cityList[province.value]
//   province.children.forEach(city => {
//     city.children = areaList[city.value]
//   })
})

export default {
  name: 'index',
  data () {
    return {
        edit: true,
        form: {
            // 个人信息
            name: '',
            age: '',
            idNumber: '',
            category: '',
            workTime: '',
            yearIncome: '',
            phone: '',
            code: '',

            // 家庭信息
            marryState: '',
            childNumber: '',
            city: '',
            detailAddress: '',
            liveHereTime: '',

        },
        result: {
          age: '',
          goodAtCategory: '',
          marryStatus: '',
          nativePlace: '',
          numberOfChildren: '',
          residenceTimeInHangzhou: '',
          team_id: '',
          user_id: '',
          user_invite_parent_id: '',
          user_is_leader: '',
          user_realname: '',
          user_serial_number: '',
          yearOfIncome: '',
          yearsOfWork: '',
          isEdit: '',
        },
        currentPicker: {
          title: '',
          type: '',
        },
        addressPicker: null  
    }
  },
  computed: {

  },
  created () {
    this.getData();
  },
  computed: {

  },
  mounted() {
    this.addressPicker = this.$createCascadePicker({
			title: '请选择城市',
			data: addressData,
			onSelect: this.selectAddressHandle,
			onCancel: this.cancelAddressHandle
		})
  },
  methods: {
    linkTo(index) {
      switch (index) {
        case 1:
          this.$router.push('/index')
          break;
        case 2:
          this.$router.push('/certificate')
          break;
        case 3:
          this.$router.push('/score')
          break;
        case 4:
          this.$router.push('/team')
      }
    },
    back(){
        this.$router.back()
    },
    getData() {
      getUserInfo().then(res => {
        console.log(res)
        this.result = res.data;
      })
    },
    submit() {
			if (this.check1() && this.check2()) {
        console.log({
					"age": this.form.age,
					"goodAtCategory": this.form.category,
					"yearsOfWork": this.form.workTime,
					"yearOfIncome": this.form.yearIncome,
					"marryStatus": this.form.marryState,
					"numberOfChildren": this.form.childNumber,
					"nativePlace": this.form.city,
					"address": this.form.detailAddress,
					"residenceTimeInHangzhou": this.form.liveHereTime,
					"userDeviceInfo": navigator.userAgent,	
				})
				supplyUserInfo({
					"age": this.form.age,
					"goodAtCategory": this.form.category,
					"yearsOfWork": this.form.workTime,
					"yearOfIncome": this.form.yearIncome,
					"marryStatus": this.form.marryState,
					"numberOfChildren": this.form.childNumber,
					"nativePlace": this.form.city,
					"address": this.form.detailAddress,
					"residenceTimeInHangzhou": this.form.liveHereTime,
					"userDeviceInfo": navigator.userAgent,	
				}).then(res => {
            if(res.errorCode==200){
                this.$createToast({
                  txt: '补充信息成功',
                  type: 'txt'
                }).show();
            this.getData();
            }else{
                this.$createToast({
                  txt: res.errorMsg,
                  type: 'txt'
                }).show();
            }
				}).catch(err => {
					this.$createToast({
						txt: '网络错误',
						type: 'txt'
					}).show();
				})

			}
		},
    showPicker(type) {
			let column;
			if (type == 1) {
				column = column1;
				this.currentPicker.type = 1
				this.currentPicker.title = '请选择品类'
			}
			if (type == 2) {
				column = column2;
				this.currentPicker.type = 2
				this.currentPicker.title = '请选择婚姻状况'
			}
			// if (!this.picker) {
			this.picker = this.$createPicker({
				title: this.currentPicker.title,
				data: [column],
				onSelect: this.selectHandle,
				onCancel: this.cancelHandle
			})
			// }
			this.picker.show()
		},
		selectHandle(selectedVal, selectedIndex, selectedText) {
			// this.$createDialog({
			// 	type: 'warn',
			// 	content: `Selected Item: <br/> - value: ${selectedVal.join(', ')} <br/> - index: ${selectedIndex.join(', ')} <br/> - text: ${selectedText.join(' ')}`,
			// 	icon: 'cubeic-alert'
			// }).show()
			console.log(selectedVal, selectedIndex, selectedText)
			if (this.currentPicker.type === 1) {this.form.category = selectedVal[0]} 
			if (this.currentPicker.type === 2) {
				this.form.marryState = selectedVal[0];
				if (selectedVal[0] == '未婚') {
					this.form.childNumber = '0';
				}
			} 
			
		},
		cancelHandle() {
			// this.$createToast({
			// 	type: 'correct',
			// 	txt: 'Picker canceled',
			// 	time: 1000
			// }).show()
		},
		showAddressPicker() {
			this.addressPicker.show()
		},
		selectAddressHandle(selectedVal, selectedIndex, selectedText) {
			// this.$createDialog({
			// 	type: 'warn',
			// 	content: `Selected Item: <br/> - value: ${selectedVal.join(', ')} <br/> - index: ${selectedIndex.join(', ')} <br/> - text: ${selectedText.join(' ')}`,
			// 	icon: 'cubeic-alert'
			// }).show()
			this.form.city = selectedText[0] + selectedText[1]
		},
		cancelAddressHandle() {
			// this.$createToast({
			// 	type: 'correct',
			// 	txt: 'Picker canceled',
			// 	time: 1000
			// }).show()
    },
    // 前端较验个人信息
		check1 () {
			if (this.form.age == '') {
				this.$cToast('请输入年龄')
				return false
			}
			if (!validateNumber(this.form.age)) {
				this.$cToast('年龄必须为整数')
				return false
			}
			if (this.form.category == '') {
				this.$cToast('请选择擅长品类')
				return false
			}
			if (this.form.workTime == '') {
				this.$cToast('请输入从业时间')
				return false
			}
			if (!validateFloatNumber(this.form.workTime)) {
				this.$cToast('从业时间必须为数字')
				return false
			}
			if (this.form.yearIncome == '') {
				this.$cToast('请输入年收入')
				return false
			}
			if (!validateFloatNumber(this.form.yearIncome)) {
				this.$cToast('年收入必须为数字')
				return false
			}
			return true
		},
		// 前端较验家庭信息
		check2 () {
			if (this.form.marryState == '') {
				this.$cToast('请选择婚姻状况')
				return false
			}
			if (this.form.childNumber == '') {
				this.$cToast('请输入子女数量')
				return false
			}
			if (!validateNumber(this.form.childNumber)) {
				this.$cToast('子女数量必须为整数')
				return false
			}
			if (this.form.city == '') {
				this.$cToast('请输入籍贯')
				return false
			}
			if (this.form.detailAddress == '') {
				this.$cToast('请输入详细地址')
				return false
			}
			if (this.form.liveHereTime == '') {
				this.$cToast('请输入居住时间')
				return false
			}
			if (!validateFloatNumber(this.form.liveHereTime)) {
				this.$cToast('居住时间必须为数字')
				return false
			}
			return true
		},
  }
}
</script>

<style scoped>
  .backWrap{
      font-size: 0.35rem;padding: 0.1rem 0.4rem; letter-spacing: 1px; font-weight: bold;
  }
	#nav { z-index: 2; position: fixed; top: 0; opacity: 1; transition: 0.5s; width: 100%; padding: 0 0.3rem; max-width: 768px; height: 0.8rem; background: #fff; box-shadow: 0 0 10px #ccc; display: flex; justify-content: space-between;}
    #nav li {line-height: 0.8rem; text-align: center; }
    #nav li a { text-decoration: none; display: block; color: #333; font-size: 0.3rem;}
    #nav li.current a { color:#de7a31;   }
    #nav li i { width: 0.25rem; height: 0.27rem; display: inline-block; vertical-align: middle; margin-right: 2px; }
    #nav li.current i {background: url(../assets/icon_select.png) no-repeat; background-size: cover;}
    .container {padding: 1.36rem 0 0.5rem;}
	.section {padding: 0 0.4rem 0.8rem;}
	.section-title { padding: 0.5rem 0 0.3rem; font-size: 0.4rem; color: #333;}
    .section-sub-title { font-size: 0.32rem; color: #333; }

    .line-50, .line-100 {
      float: left;
      position: relative;
      min-height: 0.5rem;
      padding-left: 1.6rem;
      padding-top: 0.4rem;
      box-sizing: border-box;
    }
    .line-50 {
      width: 50%;
    }
    .line-100 {
      width: 100%;
    }
    .line  .label {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 1.2rem;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.3rem;
      color: #333;
      overflow: hidden;
      text-align: justify;
      font-weight: bold;
    }
    .line .text {
      display: block;
      font-size: 0.3rem;
      color: #666;
      line-height: 0.4rem;
      height: 0.4rem;
    }
    .label::after{
      content: ' ';
      display: inline-block;
      width:100%;
      height:0;
    }
    .line .input {
      display: block;
      font-size: 0.3rem;
      color: #333;
      width: 80%;
      line-height: 0.5rem;
      height: 0.5rem;
      border-bottom: 1px solid #ccc;
    }
    .line .unit {
      position: absolute;
        bottom: 0;
        left: 84%;
        padding: 0 0.1rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.3rem;
        font-style: normal;
        color: #333;
    }
    .line  .icon_down {
      position: absolute;
      bottom: 0;
      left: 80%;
      border: 0.14rem solid transparent;
      border-top-color: #999;
      border-top-width: 0.2rem;
    }
    .see-detail {
      margin: 0.8rem 0 0.2rem;
      width: 2.4rem;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      color: #de7a31;
      border: 1px solid #de7a31;
      border-radius: 0.1rem;
    }
    .no-score {
      padding: 0.8rem 0;
      text-align: center;
      color: #aaa;
      font-size: 0.3rem;
    }
    .add-invite .add-btn {
        color: #fff;
        background: #df7a32;
        border-radius: 0.1rem;
        width: 2.3rem;
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: center;
        margin: 0.5rem auto 0.3rem;
        display: block;
    }
</style>

